// Components, Layouts, Pages
import { AdministrativeAreaPageAdmin, DashboardPageAdmin, TuitionAreaPageAdmin } from '~/pages/admin';
import { IRouteModel } from '~/utils/interface/base';
// Others
// Styles, images, icons

export const adminRoute = {
  base: '/admin',

  // Common
  commonCreate: '/create',
  commonDetail: '/:id',

  tuitionArea: '/tuition-area',
  administrativeArea: '/exam-area',
};

export const privateAdminRoutes: IRouteModel[] = [
  {
    index: true,
    path: `${adminRoute.base}`,
    component: DashboardPageAdmin,
    name: 'Dashboard',
  },
  {
    index: true,
    path: `${adminRoute.base}${adminRoute.tuitionArea}`,
    component: TuitionAreaPageAdmin,
    name: 'TuitionArea',
  },
  {
    index: true,
    path: `${adminRoute.base}${adminRoute.administrativeArea}`,
    component: AdministrativeAreaPageAdmin,
    name: 'AdministrativeArea',
  },
];

export const adminRouteAbsolute = {
  dashboard: `${adminRoute.base}`,
};
